import Input from 'antd-core/es/input/Input';
import styled from 'styled-components';
import { width } from '../../styling/mixins/width.js';
import { height } from '../../styling/mixins/height.js';
import { margin, marginBottom, marginLeft, marginRight, marginTop } from '../../styling/mixins/margin.js';
import { padding, paddingBottom, paddingLeft, paddingRight, paddingTop } from '../../styling/mixins/padding.js';

const Root = styled(Input) `
  text-overflow: ellipsis;

  input {
    text-overflow: ellipsis;
  }

  .tend-ui-input-prefix,
  .tend-ui-input-suffix {
    color: ${props => props.$theme.colors.gray500};
  }

  &.tend-ui-input,
  &.tend-ui-input-affix-wrapper {
    ${width};
    ${height};
    ${margin};
    ${marginBottom};
    ${marginLeft};
    ${marginRight};
    ${marginTop};
    ${padding};
    ${paddingBottom};
    ${paddingLeft};
    ${paddingRight};
    ${paddingTop};
  }
`;

export { Root };
//# sourceMappingURL=styled.js.map
